/**
 * Shared constants for WeaveProjectTab components
 */

// Layout constants
export const LIST_ITEM_HEIGHT = 52; // px - height of each list item
export const LIST_ITEM_LIMIT = 5;
export const LIST_CONTAINER_HEIGHT = LIST_ITEM_HEIGHT * LIST_ITEM_LIMIT; // 260px (5 rows × 52px)

// Formatting thresholds
export const TOKEN_MILLION_THRESHOLD = 1000000;
export const TOKEN_THOUSAND_THRESHOLD = 1000;
export const COST_MIN_THRESHOLD = 0.0001;
export const LATENCY_MS_THRESHOLD = 0.01; // 10ms
export const LATENCY_S_THRESHOLD = 1; // 1 second

// Time conversion constants
export const MS_PER_HOUR = 3600000;
export const MS_PER_DAY = 86400000;

// Weave query columns for calls
export const CALL_QUERY_COLUMNS = [
  'id',
  'trace_id',
  'op_name',
  'display_name',
  'started_at',
  'ended_at',
  'exception',
  'wb_user_id',
  'summary',
];

// Object section constants
export const OBJECT_CARD_LIMIT = 6; // Maximum number of object cards to display
export const EMPTY_STATE_MIN_HEIGHT = 192; // px - minimum height for empty states (h-48 = 12rem = 192px)

// Weave operation names
export const EVALUATION_OP_NAME = 'Evaluation.evaluate';

// Object type icon mapping
export const OBJECT_TYPE_ICONS = {
  model: 'model' as const,
  dataset: 'table' as const,
  evaluation: 'benchmark-square' as const,
};
